export const sscerxingzuxuanqianerbaodan = {
	balls:[
	    [-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]
	],
    num:[
	    [0,1,2,3,4,5,6,7,8,9]
    ],
    views:[
	    [0,1,2,3,4,5,6,7,8,9]
    ],
    titles: [
        '包胆'
    ],
    limitBet: true,
    getLottery:(num,balls)=>{
        let str = '';
        for(let i = 0,len_i = balls.length;i < len_i;i++){
		    for(let j = 0,len_j = balls[i].length;j < len_j;j++){
			    if(balls[i][j] > 0){
                   str = num[i][j];
                   return str;
				}
		    }
    	}
	    return str;
    },
    getNum:(balls)=>{
        let num = 0;
        for(let i=0,len=balls.length;i<len;i++){
            for(let j=0,len_j = balls[i].length;j<len_j;j++){
                if(balls[i][j]>-1){
                    return 9
                }
            }
        }
        return num;
    },
    getView: (views,balls)=>{
        let str = ''; 
        for(let i = 0,len_i = balls.length;i < len_i;i++){
		    for(let j = 0,len_j = balls[i].length;j < len_j;j++){
			    if(balls[i][j] > 0){
                    str = views[i][j];
                    return str
				}
		    }
    	}
	    return str;
    }
}
